module.exports = __webpack_public_path__ + "img/kp4.de177864.png";